import React from "react";
import "./WelcomeCard.css";
import TherapistsCard from "./TherapistsCard";

const WelcomeCard = ({ therapists }) => {
  return (
    <div className="welcomeCardContainer">
      <div className="welcomeCard">
        <div className="welcomeCardTitle">
          Welcome to Counseling and Psychotherapy Associates of Georgia
        </div>
        <div className="welcomeCardContent"></div>
        <TherapistsCard therapists={therapists} />
      </div>
    </div>
  );
};

export default WelcomeCard;
